<template>
    <div class="search-by-name-component"
        data-dusk="search-by-name-component">
        <a-input-group compact>
            <a-input @input="onLastNameInput" :value="lastName" style="width: 60%"
                     placeholder="Achternaam"
                     v-on:keyup.enter="onCustomerSearch"
                     data-dusk="input-last-name"
            />
            <a-input @input="onInitialsInput" :value="initials" style="width: 20%"
                     placeholder="Initialen"
                     v-on:keyup.enter="onCustomerSearch"
                     data-dusk="input-initials"
            />
            <a-button style="width: 20%" type="primary" v-on:click="onCustomerSearch">
                <a-icon type="search"/>
                Zoeken
            </a-button>
        </a-input-group>
        <a-list bordered size="small" v-if="showResults" class="results" itemLayout="horizontal">
            <SelectableResultComponent v-on:customer-selected="onCustomerSelected" :customer="customer" :key="index"
                                       :is-active="isActive(customer)"
                                       v-for="(customer, index) in searchResults"/>
        </a-list>
        <div v-if="showResults"></div>
    </div>
</template>

<script>
import SelectableResultComponent from './SelectableResultComponent'
import customerApi from '~/api/customer'

export default {
  name: 'SearchByNameComponent',
  components: { SelectableResultComponent },
  props: {
    clearResultsAfterSelection: {
      type: Boolean,
      required: false,
      default: true
    },
    value: {
      type: Object,
      default: null,
    }
  },
  data () {
    return {
      showResults: false,
      searchResults: [],
      lastName: '',
      initials: '',
      timeout: null
    }
  },
  mounted () {
  },
  computed: {},
  methods: {
    onCustomerSelected (customer) {
      if (this.clearResultsAfterSelection) {
        this.showResults = false
        this.lastName = ''
        this.initials = ''
        this.searchResults = []
      }
      this.$emit('customer-selected', customer)
    },
    onCustomerSearch () {
      if (this.lastName.length < 2) {
        this.showResults = false
        this.searchResults = []
      } else {
        customerApi.searchByName(this.lastName, this.initials, 100, 'current_visit_customer_property.property').then(response => {
          this.showResults = true
          this.searchResults = response.data
        })
      }
    },
    isActive (customer) {
      return this.value !== null
        && customer !== null
        && this.value.id === customer.id
    },
    onLastNameInput (event) {
      clearTimeout(this.timeout)
      this.lastName = event.target.value
      this.timeout = setTimeout(this.onCustomerSearch, 500)
    },
    onInitialsInput (event) {
      clearTimeout(this.timeout)
      this.initials = event.target.value
      this.timeout = setTimeout(this.onCustomerSearch, 500)
    }
  }
}
</script>
<style scoped>
.search-by-name-component {
    position: relative;
}

.search-by-name-component .results {
    width: 100%;
    background: rgba(255, 255, 255, 0.91);
    margin: 5px 0;
    max-height: 300px;
    overflow: auto;
}
</style>
